var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplaceFlm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,20v2h5.22a11.0163,11.0163,0,0,1-11.97,4.6533l-.4986,1.937A13,13,0,0,0,26,24.293V28h2V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,3a4.0045,4.0045,0,0,0-4,4,3.954,3.954,0,0,0,.5669,2.019L9.019,21.5669A3.9521,3.9521,0,0,0,7,21a4,4,0,1,0,4,4,3.954,3.954,0,0,0-.5669-2.019L22.981,10.4331A3.9518,3.9518,0,0,0,25,11a4,4,0,0,0,0-8ZM7,27a2,2,0,1,1,2-2A2.002,2.002,0,0,1,7,27ZM25,9a2,2,0,1,1,2-2A2.002,2.002,0,0,1,25,9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3A13.04,13.04,0,0,0,6,7.707V4H4v8h8V10H6.78a11.0163,11.0163,0,0,1,11.97-4.6533l.4986-1.937A13.0358,13.0358,0,0,0,16,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceFlm);
export default __webpack_public_path__ + "static/media/replace-flm.cb80c5ba6bc7678da4f81ae9c342a713.svg";
export { ForwardRef as ReactComponent };